/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z, 0–9, and common punctuation. Unknown characters are skipped when encoding; unrecognized Morse tokens become '?' when decoding.`)
};

const es_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z, 0–9, y puntuación común. Los caracteres desconocidos se omiten al codificar; los tokens Morse no reconocidos se convierten en ? al decodificar.`)
};

const de_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z, 0–9 und gängige Satzzeichen. Unbekannte Zeichen werden beim Kodieren übersprungen; nicht erkannte Morse-Tokens werden beim Dekodieren zu '?'.`)
};

const nl_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z, 0–9 en veel voorkomende interpunctie. Onbekende tekens worden overgeslagen bij codering; niet-herkende morse-tokens worden '?' bij decodering.`)
};

const fr_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z, 0–9, et la ponctuation courante. Les caractères inconnus sont ignorés lors du codage ; les jetons Morse non reconnus deviennent « ? » lors du décodage.`)
};

const it_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z, 0–9, e punteggiatura comune. I caratteri sconosciuti vengono saltati durante la codifica; i token Morse non riconosciuti diventano '?' durante la decodifica.`)
};

const pt_br2_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z, 0–9 e pontuação comum. Caracteres desconhecidos são ignorados ao codificar; tokens Morse não reconhecidos se tornam '?' ao decodificar.`)
};

const pt_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z, 0–9 e pontuação comum. Caracteres desconhecidos são ignorados ao codificar; tokens Morse não reconhecidos se tornam '?' ao decodificar.`)
};

const ja_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z、0–9、および一般的な句読点。エンコード時に不明な文字はスキップされ、デコード時に認識されないモールス信号トークンは「?」になります。`)
};

const zh_mc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z、0–9 及常见标点符号。编码时会跳过无法识别的字符；解码时无法识别的摩尔斯电码片段会显示为“?”。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_faq2_a", locale)
	if (locale === "en") return en_mc_faq2_a(inputs)
	if (locale === "es") return es_mc_faq2_a(inputs)
	if (locale === "de") return de_mc_faq2_a(inputs)
	if (locale === "nl") return nl_mc_faq2_a(inputs)
	if (locale === "fr") return fr_mc_faq2_a(inputs)
	if (locale === "it") return it_mc_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_mc_faq2_a(inputs)
	if (locale === "pt") return pt_mc_faq2_a(inputs)
	if (locale === "ja") return ja_mc_faq2_a(inputs)
	return zh_mc_faq2_a(inputs)
};